import gql from 'graphql-tag';
import apolloClient from '../../apollo/apollo';
import departments from './departments';
import { log } from 'util';
import { set } from 'lodash';

const state = {
  practitioners: null,
  services: [],
  bookings: [],
  booking: null,
  patients: [],
  patient: null,
  loading: false,
  loadingBooking: false,
  departments: null,
  archives: null
};

const getters = {
  getAllPractitioners: (state) => state.practitioners,
  getAllServices: (state) => state.services,
  getAllBookings: (state) => state.bookings,
  getBooking: (state) => state.booking,
  getAllPatient: (state) => state.patients
};

const mutations = {
  setAllPractitioners(state, practitioners) {
    state.practitioners = practitioners;
  },

  setAllServices(state, services) {
    state.services = services;
  },

  setAllBookings(state, bookings) {
    state.bookings = bookings;
  },

  updateAttendeeArriveStatus(state, { attendeeId, patientArriveStatus }) {
    for (const booking of state.bookings) {
      if (booking.attendees) {
        const attendee = booking.attendees.find(a => a.id === attendeeId);
        if (attendee) {
          attendee.patientArriveStatus = patientArriveStatus;
          break;
        }
      }
    }
  },

  setBooking(state, booking) {
    const index = state.bookings.findIndex(b => b.id === booking.id);
    if (index !== -1) {
      state.bookings[index] = booking;
    } else {
      state.bookings.push(booking);
    }
    state.booking = booking;
  },

  setAllPatient(state, patients) {
    state.patients = patients
  },

  setPatient(state, patient) {
    state.patient = patient
  },

  setLoading(state, loading) {
    state.loading = loading
  },
  setLoadingBooking(state, loadingBooking) {
    state.loadingBooking = loadingBooking
  },
  setDepartments(state, departments) {
    state.departments = departments
  },
  setArchives(state, archives) {
    state.archives = archives
  }
};

const actions = {
  async fetchPractitionersByDepartment({ commit }, departmentId) {
    if (isNaN(departmentId) || departmentId == null) {
      departmentId = 1;
    }
    try {
      commit('setLoading', true);
      const response = await apolloClient.query({
        query: gql`
          query findAllUsersByDepartmentId {
            findAllUsersByDepartmentId(departmentId: ${departmentId}, userFilter: {userType: DOCTOR}) {
              id
              listOfDepartments {
              displayName
              id
            }
              email
              contact {
              fullName
                firstName
                lastName
                email
              }
              listOfDayAvailable(dayAvailabilityFilter: {departmentId: ${departmentId}}) {
                availables {
                  fromTime
                  toTime
                }
                day
                isActive
                 breaks {
                  fromTime
                  toTime
                }
              }
              listOfAppointmentTypeService {
                color
                durationInMint
                id
                maxNumberPatient
                name
              }
              role
            }
          }
        `,
        context: {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
          },
        },
      });
      // console.log(response, "response");
      commit('setAllPractitioners', response.data.findAllUsersByDepartmentId);
      commit('setLoading', false);
    } catch (error) {
      console.error("Failed to fetch Practitioners:", error);
    }
  },

  async fetchPractitionersByDepartments({ commit }, departmentIds) {
    if (!departmentIds || departmentIds.length === 0) {
      commit('setAllPractitioners', []);
      return;
    }
    try {
      commit('setLoading', true);
      const response = await apolloClient.query({
        query: gql`
                    query findAllUsers($listOfDepartmentId: [Int]) {
                        findAllUsers(userFilter: {userType: DOCTOR, listOfDepartmentId: $listOfDepartmentId}) {
                            id
                            contact {
                                fullName
                                firstName
                                lastName
                                email
                            }
                            email
                        }
                    }
                `,
        variables: {
          listOfDepartmentId: departmentIds
        },
        context: {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
          },
        },
      });
      commit('setAllPractitioners', response.data.findAllUsers);
      commit('setLoading', false);
    } catch (error) {
      console.error("Failed to fetch Practitioners by departments:", error);
    }
  },

  async fetchAllServices({ commit }, filter) {
    try {
      const response = await apolloClient.query({
        query: gql`
          query findAllAppointmentTypeServices {
          findAllAppointmentTypeServices(filter: {type: ${filter}}) {
            type
            color
            durationInMint
            id
            maxNumberPatient
            name
            users {
              id
              contact {
              fullName
                firstName
                lastName
              }
            }
          }
        }
        `,
        context: {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
          },
        },
      });
      commit('setAllServices', response.data.findAllAppointmentTypeServices);
    } catch (error) {
      console.error("Failed to fetch Practitioners:", error);
    }
  },


  async fetchAllBookings({ commit }, payload) {
    if (Array.isArray(payload.listOfUserId)) {
      payload.listOfUserId = payload.listOfUserId.map((id) => parseInt(id));
    }
    payload.departmentId = parseInt(payload.departmentId);

    if (payload.end != null && payload.end != undefined) {
      let d = new Date(payload.end);
      d.setDate(d.getDate() - 1);
      payload.end = d.toISOString().split('T')[0].replace(/-/g, '-');
    }

    try {
      commit('setLoadingBooking', true);

      const response = await apolloClient.query({
        query: gql`
          query findAllBooking($fromDate: String, $toDate: String, $listOfUserId: [Int!], $departmentId: Int!, ) {
          findAllBooking(
            bookingFilter: {departmentId: $departmentId, fromDate: $fromDate, toDate: $toDate,listOfUserId: $listOfUserId, showCancelled: 1}
          ) {
            id
            bookingDate
            endTime
            startTime
            maxPatient
            note
            status
            appointmentTypeService {
              type
              category
              color
              id
              maxNumberPatient
              durationInMint
              description
              name
            }
            serviceTypeId
            serviceType {
              id
              name
            }
            user {
              contact {
              fullName
                firstName
                lastName
              }
              id
              email
            }
              attendees {
                notes
                id
                cancellationNote
                cancellationReason
                patientId
                patient {
                  id
                  contact {
                    fullName
                    firstName
                    lastName
                  }
                }
                patientArriveStatus
                patientTreatmentNote {
                  treatmentNote {
                    name
                  }
                  status
                }
              }
          }
        }
        `,
        variables: {
          fromDate: payload?.start ?? null,
          toDate: payload?.end ?? null,
          listOfUserId: payload?.listOfUserId ?? [],
          departmentId: payload?.departmentId ?? 1

          // fromDate: "2025-05-31",
          // toDate: "2025-05-31",
          // listOfUserId: [6160],
          // departmentId: 65
        },
        context: {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
          },
        },
      });

      commit('setAllBookings', response.data.findAllBooking);
      commit('setLoadingBooking', false);
    } catch (error) {
      console.error("Failed to fetch Bookings:", error);
    }
  },

  async addBooking({ commit, dispatch }, payload) {

    // console.log(payload, "addBooking");
    const booking = payload.booking;

    try {
      const response = await apolloClient.mutate({
        mutation: gql`
          mutation createBooking($endTime: String!, $startTime: String!, $bookingDate: String!, $userId: Int!, $serviceId: Int!, $maxPatient: Int, $repeatBy: RepeatedByEnum, $endAfter: Int!, $repeatEvery: Int!, $departmentId: Int!, $serviceTypeId: Int, $patientId: Int, $note: String) {
            createBooking(bookingInput: {departmentId: $departmentId, serviceTypeId: $serviceTypeId, endTime: $endTime, startTime: $startTime, bookingDate: $bookingDate, userId: $userId, appointmentTypeServiceId: $serviceId, maxPatient: $maxPatient, repeatBy: $repeatBy, endAfter: $endAfter, repeatEvery: $repeatEvery, listOfPatients: {patientId: $patientId}, note: $note}) {
              id
              bookingDate
              endTime
              startTime
              note
              appointmentTypeService {
                category
                color
                id
                maxNumberPatient
                durationInMint
                description
                name
              }
              serviceType {
                id
                name
              }
              user {
                contact {
                  firstName
                  lastName
                }
                email
                id
              }
              attendees {
                notes
                id
                cancellationNote
                cancellationReason
                patientId
                patient {
                  id
                  contact {
                    firstName
                    lastName
                  }
                }
                patientArriveStatus
              }
            }
          }
        `,
        variables: {
          endTime: booking.end,
          startTime: booking.start,
          bookingDate: booking.date,
          userId: parseInt(booking.category),
          serviceId: booking.service.id,
          maxPatient: booking.service.maxNumberPatient,
          repeatBy: booking.repeatBy,
          endAfter: parseInt(booking.endAfter),
          repeatEvery: parseInt(booking.repeatEvery),
          departmentId: payload.departmentId,
          serviceTypeId: booking.serviceTypeId ? parseInt(booking.serviceTypeId) : null,
          patientId: payload.patientId,
          note: booking.note
        },
        context: {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('accessToken') || '',
          },
        },
      });

      if (response.errors && response.errors.length > 0) {
        throw new Error(response.errors[0].message);
      }

      // commit('setBooking', response.data.createBooking);
      dispatch('fetchAllBookings', { start: payload.start, end: payload.end, listOfUserId: payload.listOfUserId, departmentId: payload.departmentId });

    } catch (error) {
      console.error('Failed to create Booking:', error.message);
      throw error; // Re-throw to allow UI to handle the error
    }
  },

  async fetchSingleBooking({ commit }, id) {
    try {
      const response = await apolloClient.query({
        query: gql`
          query findOneBookingById($bookingId: Int!) {
            findOneBookingById(id: $bookingId) {
            appointmentTypeService {
              type
              durationInMint
              name
              id
            }
            serviceType {
              id
              name
            }
            note
            bookingDate
            maxPatient
            endTime
            id
            startTime
            repeatBy
            endAfter
            repeatEvery
            userId
            status
            lastModifiedDate
            user {
            contact {
              firstName
              lastName
            }
          }
            attendees {
            notes
            cancellationNote
            cancellationReason
            id
            patientId
            patient {
              contact {
                firstName
                lastName
                fullName
                contactPhones {
                  phone
                  type
                }
                email
              }
              
              previousAttendees(booking_id: $bookingId, limit: 1) {
                booking {
                  bookingDate
                  startTime
                  id
                  user {
                    contact {
                      fullName
                    }
                  }
                }
              }
              
              nextAttendees(booking_id: $bookingId, limit: 1) {
                booking {
                  bookingDate
                  startTime
                  id
                  user {
                    contact {
                      fullName
                    }
                  }
                }
              }
            }
            patientArriveStatus
            patientTreatmentNote {
              treatmentNote {
                name
              }
              status
            }
          }
          }
          }
        `,
        variables: { bookingId: parseInt(id) },
        context: {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('accessToken') || '',
          },
        },
      });

      commit('setBooking', response.data.findOneBookingById);
    } catch (error) {
      console.error('Failed to fetch a Booking:', error);
    }
  },

  async updateBooking({ commit, dispatch }, { booking, patients, start, end, listOfUserId, departmentId, note }) {
    try {
      departmentId = parseInt(departmentId);
      const response = await apolloClient.mutate({
        mutation: gql`
          mutation updateBooking($id: Int!, $endTime: String!, $startTime: String!, $bookingDate: String!, $userId: Int!, $serviceId: Int, $maxPatient: Int, $patientsId: [BookingPatientInput], $repeatBy: RepeatedByEnum, $endAfter: Int, $repeatEvery: Int, $applyToAllOccurrence: Int, $departmentId: Int!, $serviceTypeId: Int, $note: String) {
            updateBooking(
              id: $id
              bookingInput: {
                departmentId: $departmentId,
                serviceTypeId: $serviceTypeId,
                endTime: $endTime,
                maxPatient: $maxPatient,
                listOfPatients: $patientsId,
                appointmentTypeServiceId: $serviceId,
                userId: $userId,
                bookingDate: $bookingDate,
                startTime: $startTime,
                repeatBy: $repeatBy,
                repeatEvery: $repeatEvery,
                endAfter: $endAfter,
                applyAttendanceToAllOccurrence: 0, 
                applyToAllOccurrence: $applyToAllOccurrence,
                note: $note
              }
            ) {
              appointmentTypeService {
                type
                durationInMint
                name
                id
              }
              serviceType {
                id
                name
              }
              note
              bookingDate
              maxPatient
              endTime
              id
              startTime
              repeatBy
              endAfter
              repeatEvery
              lastModifiedDate
              userId
              user {
                contact {
                  firstName
                  lastName
                }
              }
              attendees {
                notes
                id
                cancellationNote
                cancellationReason
                patientId
                patient {
                  contact {
                    firstName
                    lastName
                    fullName
                    contactPhones {
                      phone
                      type
                    }
                    email
                  }
                  nextAttendees(booking_id: $id, limit: 1) {
                    booking {
                      bookingDate
                      startTime
                      id
                      user {
                        contact {
                          fullName
                        }
                      }
                    }
                  }
                }
                patientArriveStatus
                patientTreatmentNote {
                  treatmentNote {
                    name
                  }
                  status
                }
              }
            }
          }
        `,
        variables: {
          id: booking.id,
          endTime: booking.endTime,
          startTime: booking.startTime,
          bookingDate: booking.bookingDate,
          userId: parseInt(booking.userId),
          serviceId: booking?.appointmentTypeService?.id,
          maxPatient: booking.maxPatient,
          patientsId: patients,
          repeatBy: booking.repeatBy,
          endAfter: parseInt(booking.endAfter),
          repeatEvery: booking.repeatEvery,
          applyToAllOccurrence: booking.applyToAllOccurrence,
          departmentId: departmentId,
          serviceTypeId: (booking.serviceTypeId || booking.serviceType?.id) ? parseInt(booking.serviceTypeId || booking.serviceType?.id) : null,
          note: note
        },
        context: {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('accessToken') || '',
          },
        },
      });
      if (response.errors && response.errors.length > 0) {
        throw new Error(response.errors[0].message);
      } else {

        commit('setBooking', response.data.updateBooking);
        dispatch('fetchAllBookings', { start: start, end: end, listOfUserId: listOfUserId, departmentId: departmentId });

      }

    } catch (error) {
      console.error('Failed to update booking', error.message);
      throw error; // Throw instead of returning false/alert
    }
    return true;

  },
  async addPatients({ commit, dispatch }, { booking, patients, start, end, listOfUserId, departmentId }) {
    try {
      const response = await apolloClient.mutate({
        mutation: gql`
          mutation updateBooking($departmentId: Int!, $id: Int!, $endTime: String!, $startTime: String!, $bookingDate: String!, $userId: Int!, $serviceId: Int!, $maxPatient: Int!, $patientsId: [BookingPatientInput]!, $repeatBy: RepeatedByEnum, $endAfter: Int!, $repeatEvery: Int!, $applyAttendanceToAllOccurrence: Int!, $serviceTypeId: Int) {
            updateBooking(
              id: $id
              bookingInput: {
                departmentId: $departmentId, 
                serviceTypeId: $serviceTypeId, 
                listOfPatients: $patientsId,
                endTime: $endTime,
                maxPatient: $maxPatient,
                appointmentTypeServiceId: $serviceId,
                userId: $userId,
                bookingDate: $bookingDate,
                startTime: $startTime,
                repeatBy: $repeatBy,
                repeatEvery: $repeatEvery,
                endAfter: $endAfter,
                applyAttendanceToAllOccurrence: $applyAttendanceToAllOccurrence,
                applyToAllOccurrence: $applyAttendanceToAllOccurrence
              }
            ) {
                appointmentTypeService {
                    type
                    durationInMint
                    name
                    id
                }
                bookingDate
                maxPatient
                endTime
                id
                startTime
                repeatBy
                endAfter
                repeatEvery
                userId
                user {
                    contact {
                        firstName
                        lastName
                    }
                }
                attendees {
                    notes
                    id
                    cancellationNote
                    cancellationReason
                    patientId
                    patient {
                        contact {
                            firstName
                            lastName
                        }
                    }
                    patientArriveStatus
                    patientTreatmentNote {
                        treatmentNote {
                            name
                        }
                        status
                    }
                }
            }
          }
        `,
        variables: {
          id: booking.id,
          endTime: booking.endTime,
          startTime: booking.startTime,
          bookingDate: booking.bookingDate,
          userId: booking.userId,
          serviceId: booking.appointmentTypeService.id,
          maxPatient: booking.maxPatient,
          repeatBy: booking.repeatBy,
          endAfter: booking.endAfter,
          repeatEvery: booking.repeatEvery,
          applyAttendanceToAllOccurrence: booking.applyAttendanceToAllOccurrence,
          applyAttendanceToAllOccurrence: booking.applyAttendanceToAllOccurrence,
          patientsId: patients,
          departmentId: departmentId,
          serviceTypeId: (booking.serviceTypeId || booking.serviceType?.id) ? parseInt(booking.serviceTypeId || booking.serviceType?.id) : null
        },
        context: {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('accessToken') || '',
          },
        },
      });

      if (response.errors && response.errors.length > 0) {
        alert(response.errors[0].message)
      } else {

        commit('setBooking', response.data.updateBooking);
        dispatch('fetchAllBookings', { start, end, listOfUserId, departmentId });

      }

    } catch (error) {
      alert(error.message)
      console.error('Failed to add patients:', error.message);
    }

  },

  async fetchAllPatient({ commit }, payload) {
    try {
      const response = await apolloClient.query({
        query: gql`
          query findAllPatient($patientFilter: PatientFilter) {
            findAllPatient(patientFilter: $patientFilter) {
              content {
                contact {
                  firstName
                  lastName
                  fullName
                  contactPhones {
                    phone
                  }
                }
                id
              }
            }
          }
        `,
        variables: {
          patientFilter: { search: payload?.search ?? '' }
        },
        context: {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('accessToken') || '',
          },
        },
      });
      // console.log(response.data.findAllPatient.content);
      commit('setAllPatient', response.data.findAllPatient);
    } catch (error) {
      console.error('Failed to fetch Patients:', error.message);
    }
  },

  async fetchPatientById({ commit }, id) {
    try {
      const response = await apolloClient.query({
        query: gql`
          query findOnePatientById($patientId: Int!) {
            findOnePatientById(id: $patientId) {
              id
              contact {
                fullName
              }
            }
          }
        `,
        variables: { patientId: parseInt(id) },
        context: {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('accessToken') || '',
          },
        },
      });
      // console.log(response, 'findOnePatientById');
      commit('setPatient', response.data.findOnePatientById);
    } catch (error) {
      console.error('Failed to fetch a Patient:', error);
    }
  },

  async patientArriveStatus({ commit, dispatch }, { patient, start, end, listOfUserId, departmentId }) {

    try {
      const response = await apolloClient.mutate({
        mutation: gql`
          mutation updateAttendeesArriveStatus($id: Int!, $patientArriveStatus: PatientArriveStatus!) {
            updateAttendeesArriveStatus(id: $id, patientArriveStatus: $patientArriveStatus) {
              patientArriveStatus
            }
          }
        `,
        variables: { id: patient.id, patientArriveStatus: patient.patientArriveStatus },
        context: {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('accessToken') || '',
          },
        },
      });

      dispatch('fetchAllBookings', { start, end, listOfUserId, departmentId });

    } catch (error) {
      console.error('Failed to update patient status:', error.message);
    }

  },

  async cancelBooking({ commit, dispatch }, { patientId, reason, notes, bookingId, start, end, listOfUserId, departmentId }) {
    try {
      const response = await apolloClient.mutate({
        mutation: gql`
          mutation CancelAttendee($id: Int!, $cancelAttendeeInput: CancelAttendeeInput!) {
            cancelAttendee(id: $id, cancelAttendeeInput: $cancelAttendeeInput) {
              cancellationNote
              cancellationReason
            }
          }
        `,
        variables: {
          id: patientId,
          cancelAttendeeInput: {
            cancellationReason: reason,
            cancellationReasonNote: notes
          }
        },
        context: {
          headers: {
            Authorization: 'Bearer ' + (localStorage.getItem('accessToken') || ''),
          },
        },
      });

      // dispatch('fetchSingleBooking', bookingId);
      dispatch('fetchAllBookings', { start: start, end: end, listOfUserId: listOfUserId, departmentId: departmentId });


    } catch (error) {
      console.error('Failed to cancel booking:', error.message);
    }
  },

  async archiveBooking({ commit, dispatch }, { bookingId, start, end, listOfUserId, departmentId }) {
    const response = await apolloClient.mutate({
      mutation: gql`
              mutation archiveBooking($id: Int!) {
                archiveBooking(id: $id) {
                  id
                }
              }
            `,
      variables: {
        id: bookingId,
      },
      context: {
        headers: {
          Authorization: 'Bearer ' + (localStorage.getItem('accessToken') || ''),
        },
      },
    });

    // console.log(listOfUserId.map(id => parseInt(id)), 'listOfUserId');

    dispatch('fetchArchives', listOfUserId.map(id => parseInt(id)), departmentId || '1');
    dispatch('fetchAllBookings', { start: start, end: end, listOfUserId: listOfUserId, departmentId: departmentId });
  },

  async updateAttendeeNotes({ commit, dispatch }, { booking, patients, start, end, listOfUserId, departmentId }) {

    try {
      const response = await apolloClient.mutate({
        mutation: gql`
          mutation updateBooking($departmentId: Int!, $id: Int!, $endTime: String!, $startTime: String!, $bookingDate: String!, $userId: Int!, $serviceId: Int!, $maxPatient: Int!, $repeatBy: RepeatedByEnum, $endAfter: Int!, $repeatEvery: Int!, $patientId: [BookingPatientInput]!, $serviceTypeId: Int) {
            updateBooking(
              id: $id
              bookingInput: {
                departmentId: $departmentId, 
                serviceTypeId: $serviceTypeId, 
                listOfPatients: $patientId,
                endTime: $endTime,
                maxPatient: $maxPatient,
                appointmentTypeServiceId: $serviceId,
                userId: $userId,
                bookingDate: $bookingDate,
                startTime: $startTime,
                repeatBy: $repeatBy,
                repeatEvery: $repeatEvery,
                endAfter: $endAfter,
              }
            ) {
              appointmentTypeService {
                type
                durationInMint
                name
                id
              }
              bookingDate
              maxPatient
              endTime
              id
              startTime
              repeatBy
              endAfter
              repeatEvery
              userId
              user {
                contact {
                  firstName
                  lastName
                }
              }
              attendees {
                notes
                id
                cancellationNote
                cancellationReason
                patientId
                patient {
                  contact {
                    firstName
                    lastName
                  }
                }
                patientArriveStatus
                patientTreatmentNote {
                  treatmentNote {
                    name
                  }
                  status
                }
            }
          }
        `,
        variables: {
          id: booking.id,
          endTime: booking.endTime,
          startTime: booking.startTime,
          bookingDate: booking.bookingDate,
          userId: booking.userId,
          serviceId: booking.appointmentTypeService.id,
          maxPatient: booking.maxPatient,
          repeatBy: booking.repeatBy,
          endAfter: booking.endAfter,
          repeatEvery: booking.repeatEvery,
          repeatEvery: booking.repeatEvery,
          patientId: patients,
          departmentId: departmentId,
          serviceTypeId: parseInt(booking.serviceTypeId || booking.serviceType?.id)
        },
        context: {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('accessToken') || '',
          },
        },
      });

      if (response.errors && response.errors.length > 0) {
        alert(response.errors[0].message)
      } else {
        commit('setBooking', response.data.updateBooking);
        dispatch('fetchAllBookings', { start, end, listOfUserId, departmentId });

      }
      // commit('setBooking', response.data.updateBooking);
      // dispatch('fetchAllBookings',{start,end,listOfUserId, departmentId});

    } catch (error) {
      alert(error.message)
      console.error('Failed to add patients:', error.message);
    }

  },

  async fetchDepartments({ commit }) {
    try {
      const response = await apolloClient.query({
        query: gql`
              query findAllDepartments {
                findAllDepartments {
                  id
                  name
                }
              }
            `,

        context: {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('accessToken') || '',
          },
        },
      });
      commit('setDepartments', response.data.findAllDepartments);
    } catch (error) {
      console.error('Failed to fetch Departments:', error.message);
    }
  },

  async fetchArchives({ commit }, selectedDoctors, departmentId) {
    try {
      departmentId = parseInt(departmentId) || 1;
      // console.log(departmentId, 'departmentId');
      selectedDoctors = selectedDoctors.map(id => parseInt(id));

      const response = await apolloClient.query({
        query: gql`
              query findAllArchiveBooking {
                findAllArchiveBooking(
                  bookingFilter: {departmentId: ${departmentId}, listOfUserId: ${JSON.stringify(selectedDoctors) || null}}
                ) {
                  id
                  attendees {
                    patient {
                      contact {
                        fullName
                      }
                      id
                    }
                  }
                  appointmentTypeService {
                    name
                    type
                  }
                  bookingDate
                  endTime
                  startTime
                  user {
                    contact {
                      fullName
                    }
                  }
                }
              }
            `,
        context: {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('accessToken') || '',
          },
        },
      });
      commit('setArchives', response.data.findAllArchiveBooking);
    } catch (error) {
      console.error('Failed to fetch Archives:', error.message);
    }
  },

  async reCreateCancelBooking({ commit, dispatch }, payload) {
    const booking = payload.booking;

    try {
      const response = await apolloClient.mutate({
        mutation: gql`
          mutation reCreateCancelBooking($id: Int, $endTime: String!, $startTime: String!, $bookingDate: String!, $userId: Int!, $serviceId: Int!, $serviceTypeId: Int!, $maxPatient: Int, $repeatBy: RepeatedByEnum, $endAfter: Int!, $repeatEvery: Int!, $departmentId: Int!, $patientId: Int, $note: String) {
            reCreateCancelBooking(oldCancelBookingId: $id, bookingInput: {departmentId: $departmentId, endTime: $endTime, startTime: $startTime, bookingDate: $bookingDate, userId: $userId, appointmentTypeServiceId: $serviceId, serviceTypeId: $serviceTypeId, maxPatient: $maxPatient, repeatBy: $repeatBy, endAfter: $endAfter, repeatEvery: $repeatEvery, listOfPatients: {patientId: $patientId}, note: $note}) {
              id
              bookingDate
              endTime
              startTime
              note
              appointmentTypeService {
                category
                color
                id
                maxNumberPatient
                durationInMint
                description
                name
              }
              user {
                contact {
                  firstName
                  lastName
                }
                email
                id
              }
              attendees {
                notes
                id
                cancellationNote
                cancellationReason
                patientId
                patient {
                  id
                  contact {
                    firstName
                    lastName
                  }
                }
                patientArriveStatus
              }
            }
          }
        `,
        variables: {
          id: payload.oldBookingId,
          endTime: booking.end,
          startTime: booking.start,
          bookingDate: booking.date,
          userId: parseInt(booking.category),
          serviceId: booking.service.id,
          serviceTypeId: booking.serviceTypeId,
          maxPatient: booking.service.maxNumberPatient,
          repeatBy: booking.repeatBy,
          endAfter: parseInt(booking.endAfter),
          repeatEvery: booking.repeatEvery,
          departmentId: payload.departmentId,
          patientId: parseInt(payload.patientId),
          note: booking.note
        },
        context: {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('accessToken') || '',
          },
        },
      });

      dispatch('fetchAllBookings', { start: payload.start, end: payload.end, listOfUserId: payload.listOfUserId, departmentId: payload.departmentId });
      return response;

    } catch (error) {
      console.error('Failed to recreate cancelled Booking:', error.message);
      throw error;
    }
  },

  async editAppointmentNote({ commit, dispatch }, { bookingId, note, start, end, listOfUserId, departmentId }) {
    try {
      await apolloClient.mutate({
        mutation: gql`
                mutation editAppointmentNote($bookingId: Int!, $note: String!) {
                    editAppointmentNote(bookingId: $bookingId, note: $note) {
                        note
                    }
                }
            `,
        variables: {
          bookingId,
          note
        },
        context: {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
          },
        },
      });

      dispatch('fetchAllBookings', { start, end, listOfUserId, departmentId });
    } catch (error) {
      console.error('Failed to edit appointment note:', error);
    }
  },



};

export default {
  state,
  getters,
  mutations,
  actions,
};
